import { Component } from '@angular/core';
import { LoadIndicatorService } from 'src/app/services/load-indicator.service';

@Component({
  selector: 'app-load-indicator',
  templateUrl: './load-indicator.component.html',
  styleUrls: ['./load-indicator.component.scss']
})
export class LoadIndicatorComponent {

   // eslint-disable-next-line no-useless-constructor
   constructor (private readonly loadIndicatorService: LoadIndicatorService) { }

   isShown(): boolean {
    return this.loadIndicatorService.isShown
   }
}

